export const fontFamilies = {
  regular: 'coolvetica, sans-serif',
  // light: '300',
  // book: '400',
  // regular: '500',
  // bold: '700',
};

export const fontSizes = {
  none: '0px',
  xxxs: '8px',
  xxs: '12px',
  xs: '14px',
  s: '16px',
  m: '18px',
  l: '20px',
  xl: '22px',
  xxl: '26px',
  xxxl: '30px',
  xxxxl: '34px',
};

export const lineHeights = {
  xxxxs: '12px',
  xxxs: '14px',
  xxs: '20px',
  xs: '22px',
  s: '24px',
  m: '26px',
  l: '28px',
  xl: '30px',
  xxl: '32px',
  xxxl: '38px',
  xxxxl: '40px',
};
